import React, { useState } from 'react';
import { formatPhone, isValidPhone } from '../utils/phoneMask';
import { findBooking } from '../services/api';
const bg1 = '/images/bg_1.png';
const titleTop = '/images/title_top.png';
const titleBottom = '/images/title_bottom.png';

const PhoneForm = ({ onPhoneSubmit }) => {
  const [phone, setPhone] = useState('');
  const [agreement, setAgreement] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handlePhoneChange = (e) => {
    const formatted = formatPhone(e.target.value);
    setPhone(formatted);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!isValidPhone(phone)) {
      setError('Пожалуйста, введите полный номер телефона');
      return;
    }

    if (!agreement) {
      setError('Пожалуйста, согласитесь с правилами');
      return;
    }

    setLoading(true);
    try {
      const response = await findBooking(phone);
      setLoading(false);
      onPhoneSubmit(phone, response);
    } catch (err) {
      setLoading(false);
      setError(err.message || 'Произошла ошибка при отправке запроса');
    }
  };

  return (
    <div className="wrapper">
      <div className="template">
        <div className="bg">
          <img src={bg1} alt="bg" />
        </div>
        <div className="title-top">
          <img src={titleTop} alt="title-top" />
        </div>
        <div className="title-bottom">
          <img src={titleBottom} alt="title-bottom" />
        </div>
      </div>

      <div className="container">
        <form className="form" onSubmit={handleSubmit}>
          <h2 className="title">Введите Ваш номер телефона</h2>

          <input
            type="tel"
            className="input"
            placeholder="+7 (___) ________"
            value={phone}
            onChange={handlePhoneChange}
            maxLength={18}
            disabled={loading}
          />

          <div className="checkbox-wrapper">
            <input
              type="checkbox"
              id="agreement"
              className="checkbox"
              checked={agreement}
              onChange={(e) => setAgreement(e.target.checked)}
              disabled={loading}
            />
            <label htmlFor="agreement" className="checkbox-label">
              <span className="checkbox-label-text">
                Я согласен(а) с <a href="#">правилами</a>
              </span>
            </label>
          </div>

          <button type="submit" className="button" disabled={loading}>
            {loading ? 'Отправка...' : 'Отправить'}
          </button>
        </form>
      </div>
      {error && (
        <div className="error-toast" onClick={() => setError('')}>
          {error}
        </div>
      )}
    </div>
  );
};

export default PhoneForm;

